<template>
  <v-card class="profile-section-dialog">
    <!-- start of header -->
    <v-toolbar flat class="header">
      <span class="headline">{{ layoutSetting.section.caption }}</span>
      <arb-review-checkbox
        v-if="layoutSetting.section.type === 'table' && setting.action === 'EDIT'"
        v-model="current.reviewStatusData[layoutSetting.section.fieldKey].value"
        @change="setTableDisableStatus"
      ></arb-review-checkbox>
      <arb-review-checkbox
        v-if="layoutSetting.section.type === 'table' && setting.action === 'AUDIT'"
        v-model="current.reviewStatusData[layoutSetting.section.fieldKey].value"
        type="error"></arb-review-checkbox>
      <v-spacer></v-spacer>
      <v-btn icon @click="setting.display = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- start of header //:~ -->
    <v-card-text class="content">
      <v-container class="card-text-layout">
        <!-- start of title -->
        <div class="section-banner" v-if="layoutSetting.title && layoutSetting.title instanceof Array">
          <v-layout row>
            <v-flex v-for="(title, index) in layoutSetting.title" :key="index" :class="'lg' + 12 / layoutSetting.title.length">
              <label class="m-r-20" v-if="showTitle(assist.dataType.LoanTypeEnum.INSTALLMENT_LOAN.value)">{{ title.label.installmentLoan }}</label>
              <label class="m-r-20" v-if="showTitle(assist.dataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value)">{{ title.label.multipleAdvanceLoan }}</label>
              <strong :class="title.class"> {{ assist.tool.fieldRender(current.sectionData, title.template, "currency") }} </strong>
            </v-flex>
          </v-layout>
        </div>
        <!-- end of title //:~ -->
        <!-- start of section -->
        <section-table
          v-if="layoutSetting.section.type === 'table'"
          :layoutSetting="layoutSetting"
          :current="current"
          :loan="loan"
          :setting="setting"
          :isTableDisabled="isTableDisabled"
        ></section-table>
        <section-form
          v-else
          :layoutSetting="layoutSetting"
          :current="current"
          :loan="loan"
          :setting="setting"
        ></section-form>
        <div v-if="assist.tool.isNotEmpty(layoutSetting.questionGroup) && setting.action === 'EDIT'">
          <v-divider class="no-bg m-v-20"></v-divider>
          <section-question
            :layoutSetting="layoutSetting"
            :current="current"
            :dataSource="dataSource"
          ></section-question>
        </div>
        <!-- end of section //:~ -->
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click.native="saveAction()" :loading="dialog.loading">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { LOAN_AGREEMENT_FACTOR } from '@/setting/algorithm-factor-setting'
import { OriginationBusinessApi, OriginationApi } from '@/api/pandaria'
import { DataType, Tool, Crypto, Popup } from '@/util/index'
import SectionForm from '@/components/panda/common/dialog/section/SectionForm'
import SectionQuestion from '@/components/panda/common/dialog/section/SectionQuestion'
import SectionTable from '@/components/panda/common/dialog/section/SectionTable'
const TOOL = new Tool()
const popup = new Popup()
export default {
  name: 'application-detail-dialog',
  components: {
    SectionForm,
    SectionQuestion,
    SectionTable
  },
  props: {
    loan: Object,
    slaveLoanId: Number,
    layoutSetting: Object,
    dataSource: Object,
    extension: Object,
    setting: Object
  },
  data () {
    return {
      original: {
        sectionData: {},
        reviewData: [],
        reviewStatusData: {},
        tableData: [],
        answerData: [],
        questionAnswerData: {}
      },
      current: {
        sectionData: {},
        reviewData: [],
        reviewStatusData: {},
        tableData: [],
        answerData: [],
        questionAnswerData: {}
      },
      assist: {
        tool: TOOL,
        dataType: DataType
      },
      dialog: {
        formDatePicker: false,
        tableDatePicker: [false],
        loading: false
      },
      dayOfMonthOptions: [],
      isTableDisabled: false,
      holiday: []
    }
  },
  computed: {
    display () {
      return this.setting.display
    },
    loanId () {
      return this.loan.id
    }
  },
  watch: {
    display: {
      handler: function (newVal) {
        if (newVal) {
          this.original = this.$options.data().original

          this.renderQuestionData()
          this.renderSectionData()
          this.renderReviewData()
          // this.printReviewStatus()
        } else {
          this.current.sectionData = {}
        }
      },
      immediate: true
    }
  },
  mounted () {
    if (this.layoutSetting.section.name === 'payment-option') {
      this.holiday = this.store.getters.getHoliday
    }
  },
  methods: {
    showTitle (loanType) {
      return this.loan.loanType === loanType
    },
    renderQuestionData () {
      if (TOOL.isNotEmpty(this.layoutSetting.questionGroup)) {
        this.current.answerData = []
        this.current.questionAnswerData = {}

        this.original.answerData = Object.assign(this.original.answerData, this.dataSource.answerData)
        this.original.questionAnswerData = Object.assign(this.original.questionAnswerData, this.extension.questionAnswerData)

        this.current.answerData = Object.assign(this.current.answerData, this.original.answerData)
        this.current.questionAnswerData = Object.assign(this.current.questionAnswerData, this.original.questionAnswerData)

        for (const sourceQuestionTemplate of this.dataSource.questionTemplateData) {
          let hasData = false
          for (const sourceAnswer of this.dataSource.answerData) {
            if (sourceQuestionTemplate.id === sourceAnswer.question) {
              hasData = true
            }
          }
          if (!hasData) {
            const currentQuestionAnswer = {}
            currentQuestionAnswer.text = ''
            currentQuestionAnswer.value = false
            this.current.questionAnswerData[sourceQuestionTemplate.id] = currentQuestionAnswer
          }
        }
      }
    },
    renderSectionData () {
      const type = this.layoutSetting.section.type
      /* start of table data */
      if (type === 'table') {
        this.original.tableData = JSON.parse(JSON.stringify(this.dataSource.tableData))
        this.current.tableData = JSON.parse(JSON.stringify(this.original.tableData))
      }
      /* end of table data //:~ */

      /* start of form data */
      if (type === 'form') {
        this.original.sectionData = Object.assign(this.original.sectionData, this.dataSource.sectionData)
        this.current.sectionData = Object.assign(this.current.sectionData, this.original.sectionData)
      }
      /* end of form data //:~ */
    },
    renderReviewData () {
      this.original.reviewData = Object.assign(this.original.reviewData, this.dataSource.reviewData)
      this.current.reviewData = Object.assign(this.current.reviewData, this.original.reviewData)
      if (this.setting.action === 'EDIT') {
        this.transformReview2EditJson(this.dataSource.reviewData)
      } else if (this.setting.action === 'AUDIT') {
        this.transformReview2AuditJson(this.dataSource.reviewData)
      }
    },
    transformJsonToArray (json, array, keyName, updateItemCallback, createItemCallback, formatValueCallback) {
      const keys = Object.keys(json)
      for (const key of keys) {
        let value = json[key]
        let id
        if (json[key].id) {
          id = json[key].id
        }
        if (formatValueCallback) {
          value = formatValueCallback(value)
        }

        let isExisted = false
        for (const index in array) {
          if (index >= 0) {
            const itemKey = array[index][keyName].toString()

            if (itemKey === key) {
              isExisted = true
              updateItemCallback(array[index], value, id)
              break
            }
          }
        }

        if (!isExisted) {
          const item = createItemCallback(key, value)
          array.push(item)
        }
      }
    },
    transformToAnswerData (questionAnswerData, answerData) {
      const $this = this

      this.transformJsonToArray(
        questionAnswerData,
        answerData,
        'question',
        function (item, value) {
          item.answer = value.value
        },
        function (key, value) {
          return {
            loanId: $this.loanId,
            question: parseInt(key, 10),
            answer: value.value
          }
        }
      )
    },
    transformToReviewData (reviewStatusData, reviewData) {
      const $this = this
      const feature = this.layoutSetting.section.name
      const action = this.setting.action
      this.transformJsonToArray(
        reviewStatusData,
        reviewData,
        'fieldKey',
        function (item, value) {
          item.reviewStatus = value.reviewStatus
          item.reviewStatusText = value.reviewStatusText
          if (value.id) item.id = value.id
        },
        function (key, value, id) {
          if (id) {
            return {
              loanId: $this.loanId,
              sectionKey: feature,
              fieldKey: key,
              reviewStatus: value.reviewStatus,
              reviewStatusText: value.reviewStatusText,
              id: id
            }
          } else {
            return {
              loanId: $this.loanId,
              sectionKey: feature,
              fieldKey: key,
              reviewStatus: value.reviewStatus,
              reviewStatusText: value.reviewStatusText
            }
          }
        },
        function (value) {
          let reviewStatus
          if (action === 'EDIT') {
            reviewStatus = value.value ? value.value : DataType.ReviewStatusEnum.NOT_VERIFY.value
          } else if (action === 'AUDIT') {
            reviewStatus = value[0].value
          }
          const reviewStatusText = TOOL.getEnumTextByValue(DataType.ReviewStatus, reviewStatus)

          return {
            reviewStatus: reviewStatus,
            reviewStatusText: reviewStatusText
          }
        }
      )
    },
    transformReview2EditJson (reviewData) {
      let formFields = []
      if (this.layoutSetting.section.type === 'form') {
        formFields = this.layoutSetting.formFields
      } else if (this.layoutSetting.section.type === 'table') {
        formFields = [this.layoutSetting.section]
      }

      if (this.assist.tool.isNotEmpty(reviewData)) {
        const formKeyArr = []
        const reviewKeyArr = []
        for (const fIndex in formFields) {
          if (fIndex >= 0) {
            let fieldKey = formFields[fIndex].fieldKey
            formKeyArr.push(fieldKey)
            for (const index in reviewData) {
              if (fieldKey === reviewData[index].fieldKey) {
                fieldKey = reviewData[index].fieldKey
                reviewKeyArr.push(fieldKey)
                const id = reviewData[index].id
                const reviewStatus = reviewData[index].reviewStatus
                this.original.reviewStatusData[fieldKey] = {
                  id: id,
                  value: reviewStatus
                }
                this.current.reviewStatusData[fieldKey] = {
                  id: id,
                  value: reviewStatus
                }
              }
            }
          }
        }

        // find missing field
        if (formKeyArr.length > reviewKeyArr.length) {
          let differArr = []
          differArr = formKeyArr.concat(reviewKeyArr).filter(function (v, i, arr) {
            return arr.indexOf(v) === arr.lastIndexOf(v)
          })

          for (const fieldKey of differArr) {
            this.original.reviewStatusData[fieldKey] = { value: DataType.ReviewStatusEnum.NOT_VERIFY.value }
            this.current.reviewStatusData[fieldKey] = { value: DataType.ReviewStatusEnum.NOT_VERIFY.value }
          }
        }
      } else {
        for (const fIndex in formFields) {
          if (fIndex >= 0) {
            const fieldKey = formFields[fIndex].fieldKey
            this.original.reviewStatusData[fieldKey] = { value: DataType.ReviewStatusEnum.NOT_VERIFY.value }
            this.current.reviewStatusData[fieldKey] = { value: DataType.ReviewStatusEnum.NOT_VERIFY.value }
          }
        }
      }

      if (this.layoutSetting.section.type === 'table') {
        this.isTableDisabled = this.current.reviewStatusData.statement.value === DataType.ReviewStatusEnum.VERIFY.value
      }
    },
    transformReview2AuditJson (reviewData) {
      let formFields = []
      if (this.layoutSetting.section.type === 'form') {
        formFields = this.layoutSetting.formFields
      } else if (this.layoutSetting.section.type === 'table') {
        formFields = [this.layoutSetting.section]
      }

      if (this.assist.tool.isNotEmpty(reviewData)) {
        const formKeyArr = []
        const reviewKeyArr = []
        for (const formItem of formFields) {
          let fieldKey = formItem.fieldKey
          const isEditable = formItem.isEditable
          formKeyArr.push(fieldKey)
          for (const reviewItem of reviewData) {
            if (fieldKey === reviewItem.fieldKey && isEditable !== false) {
              fieldKey = reviewItem.fieldKey
              reviewKeyArr.push(fieldKey)
              const reviewStatus = reviewItem.reviewStatus
              const id = reviewItem.id
              this.original.reviewStatusData[fieldKey] = reviewStatus
              this.current.reviewStatusData[fieldKey] = { value: reviewStatus, id: id }
            }
          }
        }

        // find missing field
        if (formKeyArr.length > reviewKeyArr.length) {
          let differArr = []
          differArr = formKeyArr.concat(reviewKeyArr).filter(function (v, i, arr) {
            return arr.indexOf(v) === arr.lastIndexOf(v)
          })
          for (const fieldKey of differArr) {
            this.current.reviewStatusData[fieldKey] = { value: DataType.ReviewStatusEnum.NOT_VERIFY.value }
          }
        }
      } else {
        for (const formField of formFields) {
          if (formField.isEditable !== false) {
            this.current.reviewStatusData[formField.fieldKey] = { value: DataType.ReviewStatusEnum.NOT_VERIFY.value }
          }
        }
      }
      if (this.layoutSetting.section.type === 'table') {
        this.isTableDisabled = this.current.reviewStatusData[formFields[0].fieldKey].value === DataType.ReviewStatusEnum.VERIFY.value
      }
    },
    saveAction () {
      for (const item of this.layoutSetting.formFields) {
        if (TOOL.isNotEmpty(item.mask) && this.assist.tool.isNotEmpty(this.current.sectionData[item.fieldKey])) {
          this.current.sectionData[item.fieldKey] = this.current.sectionData[item.fieldKey].replace(/[^0-9]/ig, '')
          this.original.sectionData[item.fieldKey] = ('' + this.original.sectionData[item.fieldKey]).replace(/[^0-9]/ig, '')
        }
      }
      const $this = this
      const blackListArray = ['ssn', 'email', 'accountNo', 'routingNo']
      const filedKeyArray = Object.keys(this.current.sectionData).filter(
        item => blackListArray.includes(item)
      )
      if (filedKeyArray.length > 0) {
        const blackListRequest = {}
        blackListRequest.portfolioId = this.loan.portfolioId
        for (const item of filedKeyArray) {
          if (TOOL.isEmpty(this.current.sectionData[item])) {
            continue
          }
          switch (item) {
            case 'accountNo':
              blackListRequest.ACCOUNTNUMBER = this.current.sectionData[item]
              break
            case 'routingNo':
              blackListRequest.ROUTINGNUMBER = this.current.sectionData[item]
              break
            default:
              blackListRequest[item.toUpperCase()] = this.current.sectionData[item]
              break
          }
        }
        if (Object.keys(blackListRequest).length !== 0) {
          OriginationBusinessApi.checkBlackList(blackListRequest, function (result) {
            const blackListField = []
            for (const item of filedKeyArray) {
              switch (item) {
                case 'accountNo':
                  if (!result.ACCOUNTNUMBER) {
                    blackListField.push(item)
                  }
                  break
                case 'routingNo':
                  if (!result.ROUTINGNUMBER) {
                    blackListField.push(item)
                  }
                  break
                default:
                  if (!result[item.toUpperCase()]) {
                    blackListField.push(item)
                  }
                  break
              }
            }

            if (blackListField.length > 0) {
              let text = ''
              for (const item of blackListField) {
                if (blackListField[blackListField.length - 1] === item) {
                  text = text + item
                } else {
                  text = text + item + ' and '
                }
              }
              popup.popupForInfo('Find ' + text + ' in black list', { title: 'Black List' })
            } else {
              $this.signStatusCheck()
            }
          })
        }
      } else {
        $this.signStatusCheck()
      }
    },
    signStatusCheck () {
      const $this = this
      let isAffectLoanAgreement = false
      if (this.layoutSetting.section.name === 'bank' && TOOL.isNotEmpty($this.current.sectionData.numberOfOpenLoans)) {
        $this.current.sectionData.numberOfOpenLoans = Number($this.current.sectionData.numberOfOpenLoans)
      }
      const updatedKeys = $this.compareData($this.original, $this.current)
      const affectedField = updatedKeys.filter(
        item => LOAN_AGREEMENT_FACTOR.includes(item)
      )
      if (affectedField.length > 0) {
        isAffectLoanAgreement = true
      }
      OriginationApi.getLoanSignData($this.loanId, function (result) {
        const signStatus = $this.assist.tool.isNotEmpty(result) ? result.signStatus : null
        if ((signStatus === DataType.SignStatusEnum.SIGNED.value) && isAffectLoanAgreement) {
          popup.popupForInfo('This change will void the previous loan agreement. Are you sure continue?', {
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
          }, function () {
            OriginationBusinessApi.voidLoanAgreement({ loanId: $this.loanId }, function (result) {
              $this.clickSaveEventHandler(updatedKeys)
            }, function (result) {
              popup.popupForWarning('Failed to void loan agreement')
            })
          })
        } else if ($this.assist.tool.isNotEmpty(signStatus) && (signStatus === DataType.SignStatusEnum.NOT_SIGNED.value) && isAffectLoanAgreement) {
          OriginationBusinessApi.suspendLoanAgreement({ loanId: $this.loanId }, function (result) {
            // $this.$eventBus.$emit('updateSignStatus', DataType.SignStatusEnum.SUSPENDED)
          })
          $this.clickSaveEventHandler(updatedKeys)
        } else if ($this.assist.tool.isNotEmpty(signStatus) && (signStatus === DataType.SignStatusEnum.IN_PROGRESS.value) && isAffectLoanAgreement) {
          popup.popupForWarning('Customer is signing the document, please try again later')
        } else if ($this.assist.tool.isNotEmpty(signStatus) && (signStatus === DataType.SignStatusEnum.RECOVER_IN_PROGRESS.value) && isAffectLoanAgreement) {
          popup.popupForWarning('Document recovery is in progress, please try again later')
        } else {
          $this.clickSaveEventHandler(updatedKeys)
        }
      }, function (result) {
        $this.clickSaveEventHandler(updatedKeys)
      })
    },
    // eslint-disable-next-line complexity
    async clickSaveEventHandler (updatedKeys) {
      try {
        this.dialog.loading = true
        const $this = this
        const type = this.layoutSetting.section.type
        const action = this.setting.action
        const feature = this.layoutSetting.section.name
        const questionGroup = this.layoutSetting.questionGroup
        const tableData = this.current.tableData

        const newSectionData = {}
        let newTableData = []
        let newAnswerData = []
        let newReviewData = []

        /* start of edit */
        if (action === 'EDIT') {
          /* start of question */
          if (questionGroup) {
            this.transformToAnswerData(this.current.questionAnswerData, this.current.answerData)

            const questionList = []
            for (const question of this.current.answerData) {
              if (question.answer !== false) {
                questionList.push(question)
              }
            }
            await OriginationApi.batchUpdateQuestionData(questionList, function (result) {
              OriginationApi.listLoanQuestionData($this.loanId, function (result) {
                newAnswerData = result
              })
            })
          }
          /* end of question //:~ */

          /* start of form */
          if (type === 'form') {
            Object.assign(newSectionData, this.current.sectionData)

            switch (feature) {
              case 'personal': {
                if (this.assist.tool.isEmpty(newSectionData.military)) {
                  newSectionData.military = 0
                }
                break
              }
              case 'payment-option': {
                for (const program of this.dataSource.programArray) {
                  // eslint-disable-next-line max-depth
                  if (program.id === newSectionData.program) {
                    newSectionData.interestRate = program.interestRate
                    break
                  }
                }

                // TODO get programId from maintenance
                if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value && feature === 'payment-option') {
                  newSectionData.program = 19
                }
                break
              }
              default: break
            }

            await Object.assign(newSectionData, { loanId: this.loanId })
            if (feature === 'payment-option') {
              const paymentOptionSaveData = {}
              if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
                paymentOptionSaveData.slaveLoanId = this.slaveLoanId
              }
              paymentOptionSaveData.effectiveDate = newSectionData.effectiveDate
              paymentOptionSaveData.program = newSectionData.program
              paymentOptionSaveData.paymentMode = newSectionData.paymentMode
              paymentOptionSaveData.loanId = this.loanId
              paymentOptionSaveData.interestRate = newSectionData.interestRate
              await OriginationApi.updateLoanFeatureData(feature, paymentOptionSaveData)
            } else {
              await OriginationApi.updateLoanFeatureData(feature, newSectionData)
            }
          }
          /* end of form //:~ */

          /* start of table */
          if (type === 'table') {
            let hasWarning = false
            const tableDataArr = []

            for (const item of tableData) {
              // eslint-disable-next-line max-depth
              if ('amount' in item && 'loanId' in item && 'balance' in item && 'payrollDate' in item &&
                'payrollType' in item && 'vob' in item) {
                tableDataArr.push(item)
              } else {
                hasWarning = true
              }
            }

            if (hasWarning) {
              popup.popupForWarning('fill it up')
              this.dialog.loading = false
              return
            }

            this.current.tableData = tableDataArr
            const requestData = { loanId: this.loanId, bankRecords: tableDataArr }
            await OriginationApi.updateLoanBankRecordsData(requestData, function (result) {
              $this.setting.display = false
              if (TOOL.isEmpty(result)) {
                result = []
              }

              for (const item of result) {
                item.payrollDate = TOOL.formatDate(item.payrollDate)
              }
              newTableData = result
            })
          }
          /* end of table //:~ */

          this.transformToReviewData(this.current.reviewStatusData, this.current.reviewData)
          /* end of edit //:~ */
        } else if (action === 'AUDIT') {
          /* start of audit */
          if (type === 'form') {
            Object.assign(newSectionData, this.current.sectionData)
            await Object.assign(newSectionData, { loanId: this.loanId })
          }
          this.transformToReviewData(this.current.reviewStatusData, this.current.reviewData)
        }
        /* end of audit //:~ */

        /* start of review */
        Object.assign(newReviewData, this.current.reviewData)
        if (this.current.reviewData.length > 0) {
          if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value && feature === 'payment-option') {
            for (const item of this.current.reviewData) {
              if (item.fieldKey === 'program') {
                item.reviewStatus = DataType.ReviewStatusEnum.VERIFY.value
                item.reviewStatusText = DataType.ReviewStatusEnum.VERIFY.text
                break
              }
            }
          }
          const reviewRequest = {
            loanId: this.loanId,
            reviewData: this.current.reviewData
          }
          await OriginationApi.batchUpdateLoanReviewData(reviewRequest)
          await OriginationApi.listLoanReviewDataRelatedAssignedLoan(this.loan.id, feature, function (result) {
            newReviewData = result
          })
        }
        /* end of review //:~ */

        /* start of emit event */
        if (this.assist.tool.isNotEmpty(newSectionData)) this.current.sectionData = newSectionData
        if (this.assist.tool.isNotEmpty(newTableData)) this.current.tableData = newTableData
        if (this.assist.tool.isNotEmpty(newAnswerData)) this.current.answerData = newAnswerData
        if (this.assist.tool.isNotEmpty(newReviewData)) this.current.reviewData = newReviewData
        this.$emit('sectionUpdated', JSON.parse(JSON.stringify(this.current)), this.setting.action, updatedKeys)
        /* end of emit event //:~ */
        this.dialog.loading = false
        this.setting.display = false
      } catch (error) {
        console.log('>>> ERROR <<<')
        console.log(error)
      }
    },
    compareData (originalData, currentData) {
      const updatedKeys = []
      // compare sectionData
      const currentReviewData = currentData.reviewStatusData
      const originalReviewData = originalData.reviewData
      const currentSectionData = currentData.sectionData
      const originalSectionData = originalData.sectionData
      const currentObject = {}
      const originalObject = {}
      const reviewedKeys = []

      for (const key of Object.keys(currentData.reviewStatusData)) {
        const statusItem = this.assist.tool.isEmpty(currentReviewData[key]) ? { value: false } : currentReviewData[key]
        if (statusItem.value === true) {
          currentObject[key] = DataType.ReviewStatusEnum.VERIFY.value
        } else {
          currentObject[key] = DataType.ReviewStatusEnum.NOT_VERIFY.value
        }
      }

      for (const item of originalReviewData) {
        originalObject[item.fieldKey] = item.reviewStatus
      }

      // review status change
      for (const key of Object.keys(currentData.reviewStatusData)) {
        if (currentObject[key] !== (TOOL.isEmpty(originalObject[key]) ? DataType.ReviewStatusEnum.NOT_VERIFY.value : originalObject[key])) {
          updatedKeys.push(key)
        } else if (currentObject[key] === DataType.ReviewStatusEnum.VERIFY.value) {
          reviewedKeys.push(key)
        }
      }

      // compare form
      if (this.assist.tool.isNotEmpty(reviewedKeys)) {
        for (const item of reviewedKeys) {
          if (currentSectionData[item] !== originalSectionData[item]) {
            updatedKeys.push(item)
          }
        }
      }

      // compare question
      if (TOOL.isNotEmpty(currentData.questionAnswerData)) {
        let answer
        const questionAnswerData = currentData.questionAnswerData[5].value
        for (const item of currentData.answerData) {
          if (item.question === 5) {
            answer = item.answer
          }
        }
        if (answer !== questionAnswerData) {
          updatedKeys.push('paydayOnAvailable')
        }
      }

      // compare table
      if (reviewedKeys[0] === 'statement') {
        const currentTable = currentData.tableData
        const originalTable = originalData.tableData
        if (Crypto.md5(JSON.stringify(currentTable)) !== Crypto.md5(JSON.stringify(originalTable))) {
          updatedKeys.push('statement')
        }
      }

      if (this.layoutSetting.section.name === 'payment-option' && this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        updatedKeys.push('program')
      }
      return updatedKeys
    },
    setTableDisableStatus () {
      if (this.setting.action === 'EDIT') {
        this.isTableDisabled = this.current.reviewStatusData[this.layoutSetting.section.fieldKey].value === DataType.ReviewStatusEnum.VERIFY.value
      } else {
        this.isTableDisabled = true
      }
    },
    printReviewStatus () {
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
  .header {
    position: relative;
    z-index: 999;
    top: 0;
    background-color: white;
  }
  .content {
    max-height: 600px;
    overflow: auto;
  }

  .card-text-layout {
    margin: -15px 0px;
    padding: -30px -20px;
  }

  .section-banner {
    margin: 10px 0;
    font-size: 25px;
  }
  span {
    min-width: 110px;
  }
</style>

<style>
  .blue--text.text--darken-1 {
    color: #00181b!important;
  }
  .v-input--radio-group--column .v-input--radio-group__input {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: unset;
    flex-direction: row;
  }
  .profile-section-dialog .theme--dark.v-btn.v-btn--disabled {
    color: rgba(0,0,0,0.42)!important;
  }
  .profile-section-dialog .theme--dark.v-btn.v-btn--disabled .v-icon {
    color: rgba(0,0,0,0.42)!important;
  }
</style>
